export const ZendeskIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="var(--icon-main, rgb(3, 54, 61))"
    viewBox="0 0 22 16"
    {...props}
  >
    <path d="M0 16h9.75V4.23zM9.75 0A4.88 4.88 0 1 1 0 0h9.75zm1.61 16a4.88 4.88 0 1 1 9.75 0h-9.75zm0-4.23V0h9.75z" />
  </svg>
);
